/* =================== SLIDE HOME =================== */
jQuery(document).ready(function ($) {
  $(".slide-home")
    .on("init", function () {
      $(".slide-content").show();
    })
    .slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      speed: 2000,
      autoplay: true,
      autoplaySpeed: 3000,
      adaptiveHeight: true,
      pauseOnFocus: false,
      pauseOnHover: false,
    })
    .on("beforeChange", function () {
      $(".slide-content").hide();
    })
    .on("afterChange", function () {
      $(".slide-content").show();
    });
});

// ------------------------------------
// Parallax
// ------------------------------------
if ($(".rellax").length > 0) {
  var rellax = new Rellax(".rellax");
}
